import { ReactNode } from 'react';

import s from './MediaDetails.module.scss';

interface IProps {
  title?: ReactNode;
  body?: ReactNode;
}

const MediaDetails: React.FC<IProps> = ({ title, body }) => (
  <div className={s.details}>
    <span className={s.title}>{title}</span>

    {body && (
      <div>
        <span className={s.information}>{body}</span>
      </div>
    )}
  </div>
);

export default MediaDetails;
